import { Controller as BaseController } from 'stimulus'

/**
 * Added globally to the whole page. Responsible to easily open any Modal based on the modal's ref ID.
 */
export default class extends BaseController {
  open(event) {
    const { currentTarget } = event

    const disabled = currentTarget.attributes.disabled !== undefined
    if (disabled) return

    const modalRefId = currentTarget.getAttribute('data-modal-opener-ref-id')
    const modalRefSelector = `[data-modal-id=${modalRefId}]`
    const modalTarget = document.getElementById(modalRefId) || document.querySelector(modalRefSelector)

    // Access the Modal's underlying Stimulus Controller
    modalTarget && modalTarget.modal?.show()
  }
}
